import React, { useEffect } from 'react';
import './committee-results.css';
import { ProgressBar } from '../../../../components/progress-bar';
import { Paragraph } from '../../../../components/paragraph';

const CommitteeResults = props => {
    const {
        committeeResults,
        committeeTargets,
        showProgressUpdateModal,
    } = props;

    const maxScore = 2.5;

    useEffect(() => {
        const progressTimeout = setTimeout(
            () => showProgressUpdateModal(),
            3000,
        );
        return () => clearTimeout(progressTimeout);
    }, [showProgressUpdateModal]);

    return (
        <div className="committee-results">
            <div>
                <Paragraph withSpacing={false} colorScheme="dark">
                    Quality of Evidence
                </Paragraph>
                <ProgressBar
                    progressValue={committeeResults.evidence}
                    maxValue={maxScore}
                    target={committeeTargets.evidence}
                />
            </div>
            <div>
                <Paragraph withSpacing={false} colorScheme="dark">
                    Range of Views
                </Paragraph>
                <ProgressBar
                    progressValue={committeeResults.views}
                    maxValue={maxScore}
                    target={committeeTargets.views}
                />
            </div>
        </div>
    );
};

export default CommitteeResults;
